import { jwtDecode } from 'jwt-decode';

export default function isTokenExpired(token) {
  const decoded = jwtDecode(token);
  const expirationEpochSeconds = decoded.exp;
  const nowEpochSeconds = Math.floor(Date.now().getTime() / 1000);
  return nowEpochSeconds > expirationEpochSeconds;
}
